import _defineProperty from "/home/runner/work/doctocat/doctocat/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { useContext, createContext } from 'react';
var FormControlContext = /*#__PURE__*/createContext(null);
var FormControlContextProvider = FormControlContext.Provider;

/** This is the private/internal interface for subcomponents of `FormControl`. */
function useFormControlContext() {
  var _useContext;
  return (_useContext = useContext(FormControlContext)) !== null && _useContext !== void 0 ? _useContext : {};
}

/**
 * Make any component compatible with `FormControl`'s automatic wiring up of accessibility attributes & validation by
 * reading the props from this hook and merging them with the passed-in props. If used outside of `FormControl`, this
 * hook has no effect.
 *
 * @param externalProps The external props passed to this component. If provided, these props will be merged with the
 * `FormControl` props, with external props taking priority.
 */

/**
 * Make any component compatible with `FormControl`'s automatic wiring up of accessibility attributes & validation by
 * reading the props from this hook and handling them / assigning them to the underlying form control. If used outside
 * of `FormControl`, this hook has no effect.
 */

function useFormControlForwardedProps() {
  var externalProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var context = useContext(FormControlContext);
  if (!context) return externalProps;
  return _objectSpread(_defineProperty({
    disabled: context.disabled,
    id: context.id,
    required: context.required,
    validationStatus: context.validationStatus
  }, 'aria-describedby', [context.validationMessageId, context.captionId].filter(Boolean).join(' ') || undefined), externalProps);
}
export { FormControlContextProvider, useFormControlContext, useFormControlForwardedProps };